/// #if PLATFORM === 'xd'
<template>
  <div class="appHeader d-flex align-items-center justify-content-between">
    <select
      class="selectOptions w-100"
      ref="selectOptions"
      :value="selectOptions"
      @change="selectOptions = $refs.selectOptions.value"
      uxp-quiet="true"
    >
      <option
        :value="stringify({
          name: 'icons-slug'
        })"
      >{{ $t('header.search') }}</option>
      <template
        v-if="isLoggedIn"
      >
        <option
          :value="stringify({
            name: 'downloads'
          })"
        >{{ $t('header.downloads') }}</option>
        <option
          :value="stringify({
            name: 'likes'
          })"
        >{{ $t('header.likes') }}</option>
        <option
          v-for="(user, index) in selectedDesigners"
          :key="index"
          :value="stringify({
            name: 'icons-slug',
            query: {
              contributors: user.username
            }
          })"
        >{{ user.name }}</option>
      </template>
      <template v-else>
        <option
          :value="stringify({
            name: 'login'
          })"
        >{{ $t('buttons.login') }}</option>
      </template>
    </select>
    <template
      v-if="!isLoggedIn"
    >
      <template
        v-if="$route.name !== 'login'"
      >
        <button
          type="button"
          uxp-variant="cta"
          uxp-quiet="false"
          @click="$router.push({ name: 'login' })"
        >{{ $t('buttons.login') }}</button>
      </template>
      <template v-else>
        <button
          type="button"
          uxp-variant="primary"
          uxp-quiet="true"
          @click="$router.push({ name: 'icons-slug' })"
        >{{ $t('buttons.back') }}</button>
      </template>
    </template>
    <template v-else>
      <select
        class="selectUser"
        ref="selectUser"
        :value="selectUser"
        @change="selectUser = $refs.selectUser.value"
        uxp-quiet="true"
      >
        <!-- Individual User -->
        <option
          :value="stringify({
            name: 'settings-account-switch',
            params: {
              type: 'personal'
            }
          })"
        >{{ individualUser.first_name }}</option>
        <!-- Team Users -->
        <option
          v-for="(team, index) in this.individualUser.teams"
          :key="index"
          :value="stringify({
            name: 'settings-account-switch',
            params: {
              type: 'team',
              uuid: team.uuid
            }
          })"
        >{{ team.name }}</option>
        <!-- Logout -->
        <option
          :value="stringify({
            name: 'logout'
          })"
        >{{ $t('buttons.logout') }}</option>
      </select>
    </template>
  </div>
</template>
/// #else
<template>
  <header :class="$style.header">
    <div :class="$style.options">
      <div :class="$style.tabs">
        <b-dropdown
          id="appHeaderIconscout"
          :text="activeTab"
          :menu-class="$style.dropdownMenu"
          @click.native="onGoToIconscout"
          :class="[$style.tab, currentTab === 'iconscout' ? 'active' : '']"
          :toggle-class="$style.btnDropdown"
          :popper-opts="{
            modifiers: {
              preventOverflow: { enabled: false }
            }
          }"
        >
          <b-dropdown-item
            :to="{
              name: 'icons-slug'
            }"
            :active-class="null"
            @click="activeText('Iconscout')"
          >{{ $t('header.iconscout') }}</b-dropdown-item>
          <template
            v-if="isLoggedIn"
          >
            <b-dropdown-item
              :to="{
                name: 'downloads'
              }"
              :active-class="null"
              @click="activeText('My Downloads')"
            >{{ $t('header.downloads') }}</b-dropdown-item>
            <b-dropdown-item
              :to="{
                name: 'likes'
              }"
              :active-class="null"
              @click="activeText('My Likes')"
            >{{ $t('header.likes') }}</b-dropdown-item>
            <b-dropdown-item
              :class="$style.subMenu"
            >
              {{ $t('header.selected') }}
              <div
                class="dropdown-menu"
              >
                <b-dropdown-item
                  v-for="(user, index) in selectedDesigners"
                  :key="index"
                  :to="{
                    name: 'icons-slug',
                    query: {
                      contributors: user.username
                    }
                  }"
                  class="px-3"
                >
                  <div
                    @click="activeText(`${user.name}`)"
                  >
                    <img
                      :src="user | profilePicture('small')"
                      height="16"
                      width="16"
                      class="mr-2 align-bottom"
                    />
                    <span>{{user.name}}</span>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item
                  :to="{
                    name: 'contributors'
                  }"
                  :class="['px-3', $style.btnAddDesigner]"
                >{{ $t('buttons.add_designer') }}</b-dropdown-item>
              </div>
            </b-dropdown-item>
          </template>
          <template
            v-else
          >
            <b-dropdown-item
              :to="{
                name: 'login'
              }"
              :active-class="null"
            >{{ $t('header.downloads') }}</b-dropdown-item>
            <b-dropdown-item
              :to="{
                name: 'login'
              }"
              :active-class="null"
            >{{ $t('header.likes') }}</b-dropdown-item>
          </template>
          <template
            v-if="prototypeSupported"
          >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              :to="{
                name: 'prototype'
              }"
              :active-class="null"
              @click="activeText('Prototype Mode')"
            >{{ $t('header.prototype') }}</b-dropdown-item>
          </template>
          <template
            v-if="quitSupported"
          >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              @click="onQuit"
            >{{ $t('header.quit') }}</b-dropdown-item>
          </template>
        </b-dropdown>
        <router-link
          v-if="!isLoggedIn"
          :to="{ name: 'login' }"
          :class="[$style.tab, currentTab === 'myscout' ? 'active' : '']"
        >{{ $t('header.myscout') }}</router-link>
        <a
          v-else
          :href="myscoutUrl"
          :class="[$style.tab, currentTab === 'myscout' ? 'active' : '']"
        >{{ $t('header.myscout') }}</a>
      </div>
    </div>
    <div
      :class="[$style.btnSettings, currentTab === 'profile' ? 'active': '']"
    >
      <router-link
        v-if="!isLoggedIn"
        :to="{ name: 'login' }"
      >
        <img
          src="@/assets/icons/login.svg"
          :class="$style.user"
          name="login"
          width="20"
          height="20"
        />
      </router-link>
      <router-link
        v-else
        :to="{ name: 'settings-account' }"
      >
        <img
          class="rounded-circle"
          :src="user | profilePicture('small')"
          width="20"
          height="20"
          :class="$style.user"
        />
      </router-link>
    </div>
  </header>
</template>
/// #endif

<script>
// import { mapState } from 'vuex'
import { webUrl } from '@/lib/route'
import Platform from '@/plugin-platforms'
import AuthMixin from '@/components/mixins/auth'

export default {
  mixins: [AuthMixin],

  data () {
    let selectUser = null
    return {
      activeTab: 'Iconscout',
      selectOptions: this.getSelectOption(),
      selectUser,
      myscoutUrl: process.env.VUE_APP_MYSCOUT_URL
    }
  },

  created () {
    this.setSelectUser()
  },

  computed: {
    currentTab () {
      const profile = 'profile'
      const myscout = 'myscout'
      switch (this.$route.name) {
        case 'settings-account':
          return profile
        case 'settings-account-switch':
          return profile
        case 'settings-plugin':
          return profile
        case 'login':
          return profile
        case 'myscout':
          return myscout
        case 'myscout-projects':
          return myscout
        case 'myscout-folders-uuid':
          return myscout
        case 'myscout-shared-with-me':
          return myscout
        case 'myscout-search':
          return myscout
      }
      return 'iconscout'
    },
    prototypeSupported () {
      return Platform.features.prototype
    },
    quitSupported () {
      return Platform.platform.indexOf('desktop') > -1
    }
  },

  watch: {
    selectOptions (value) {
      const route = JSON.parse(value)
      // If user is switching to contributor profile then set asset
      if (route.name.indexOf('s-slug') > -1) {
        const asset = route.name.replace('s-slug', '')
        this.$store.commit('settings/setAsset', asset)
      }
      this.$router.push(route)
    },
    selectUser (newValue, oldValue) {
      if (newValue && oldValue) {
        const route = JSON.parse(newValue)
        if (route.name === 'logout') {
          this.onLogout()
          this.selectUser = null
        } else {
          this.$router.push(JSON.parse(newValue))
        }
      }
    },
    user (newValue, oldValue) {
      // Change selectedUser only if there is new/old user
      // In case of Logout there's no user
      if (newValue !== oldValue) {
        this.setSelectUser()
      }
    }
  },

  updated () {
    const newOption = this.getSelectOption()
    // console.warn('updated', this.selectOptions, newOption, newOption !== this.selectOptions)
    if (newOption !== this.selectOptions) {
      this.selectOptions = newOption
    }
  },

  methods: {
    onGoToIconscout (e) {
      // If User has clicked on the dropdown div itself
      if (e.srcElement.id === 'appHeaderIconscout') {
        this.activeTab = 'Iconscout'
        this.$router.push({
          name: 'icons-slug'
        })
      }
    },
    activeText (value) {
      this.activeTab = value
    },
    getSelectOption () {
      let contributors = null
      if (this.$route.query.contributors) {
        const user = this.selectedDesigners.find(u => u.username === this.$route.query.contributors)
        if (user) {
          contributors = user.username
        }
      }

      const defaultOption = JSON.stringify({
        name: 'icons-slug',
        ...contributors ? {
          query: {
            contributors: contributors
          }
        } : false
      })

      let currentOption = JSON.stringify({
        name: this.$route.name,
        ...this.$route.params ? this.$route.params : false,
        ...contributors ? {
          query: {
            contributors: contributors
          }
        } : false
      })

      // Icons/Illustrations/Photos are same route
      // console.log('index', ['icons-slug', 'illustrations-slug', 'photos-slug'].indexOf(this.$route.name), !contributors)
      if (['icons-slug', 'illustrations-slug', 'photos-slug'].indexOf(this.$route.name) > -1 && !contributors) {
        currentOption = defaultOption
      }

      const options = []
      if (this.$refs.selectOptions) {
        for (let index = 0; index < this.$refs.selectOptions.children.length; index++) {
          const element = this.$refs.selectOptions.children[index]
          options.push(element.value)
        }
      }

      // console.log(options.indexOf(currentOption), currentOption)
      if (options.indexOf(currentOption) === -1) {
        currentOption = defaultOption
      }

      return currentOption
    },
    setSelectUser () {
      if (this.isTeam) {
        this.selectUser = JSON.stringify({
          name: 'settings-account-switch',
          params: {
            type: 'team',
            uuid: this.user.uuid
          }
        })
      } else {
        this.selectUser = JSON.stringify({
          name: 'settings-account-switch',
          params: {
            type: 'personal'
          }
        })
      }
    },
    stringify: obj => JSON.stringify(obj),
    onSignup () {
      let url = webUrl('signup')
      Platform.openURL(url)
    },
    onQuit () {
      Platform.quit()
    }
  }
}
</script>

/// #if PLATFORM !== 'xd'
<style lang="scss" module>
.header {
  display: table;

  .options {
    display: table-cell;
    vertical-align: top;
    width: 100%;

    .tabs {
      display: table;
      width: 100%;
      font-size: $font-size-lg;
      font-weight: $font-weight-semi-bold;
      padding: 0;
      vertical-align: middle;

      > div {
        display: table-cell;
        width: 50%;
      }

      .tab {
        display: inline-block;
        padding: 9px;
        width: 50%;
        // float: left;
        font: inherit;
        text-align: center;
        color: var(--typo-2);
        background-color: var(--bg-1);
        border: 1px solid var(--border-1);
        border-top: 0;
        border-right: 0;
        box-shadow: none;
        transition: initial;
        border-radius: 0;
        cursor: pointer;

        &:hover {
          background: var(--bg-2);
          // border-color: transparent;
        }

        &:global(.active) {
          background-color: var(--bg-2);
          border-bottom-color: transparent;
        }
      }
    }
  }

  .btnDropdown {
    background: transparent !important;
    font-weight: inherit;
    font-size: inherit;
    padding: initial;
    color: inherit !important;
    border: 0;
    line-height: 1;
  }

  .btnSettings {
    display: table-cell;
    vertical-align: top;
    background-color: var(--bg-1);
    color: var(--typo-2);
    border: 1px solid var(--border-1);
    width: 32px;
    height: 32px;
    padding: 9px;
    line-height: 10px;
    border-top: 0;

    @include svg-fill(var(--typo-2));

    &:global(.active) {
      background-color: var(--bg-2);
      border-bottom-color: transparent;
      border-right-color: transparent;
    }

    .user {
      margin: -3px;
    }
  }
}
.dropdownMenu {
  min-width: 100%;
  transform: none !important;
  top: 34px !important;
}
.subMenu {
  position: relative;

  @include caret(right);
  &:after {
    position: absolute;
    top: 9px;
    right: 15px;
  }

  :global(.dropdown-menu) {
    top: - $dropdown-spacer;
    left: 100%;
    min-width: 100%;
  }

  &:hover {
    :global(.dropdown-menu) {
      display: block !important;
    }
  }
}

.btnAddDesigner {
  background: var(--bg-2);
  position: relative;
  border: 1px solid var(--bg-3);
  top: 6px;
  font-weight: $font-weight-bold;
  color: $primary;
  @include border-bottom-radius($border-radius);

  &:hover {
    color: $white !important;
  }
}
</style>
/// #endif
